import { render, staticRenderFns } from "./AIChatWidgetActionButtons.vue?vue&type=template&id=55601638&scoped=true"
import script from "./AIChatWidgetActionButtons.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetActionButtons.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetActionButtons.vue?vue&type=style&index=0&id=55601638&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55601638",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55601638')) {
      api.createRecord('55601638', component.options)
    } else {
      api.reload('55601638', component.options)
    }
    module.hot.accept("./AIChatWidgetActionButtons.vue?vue&type=template&id=55601638&scoped=true", function () {
      api.rerender('55601638', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatWidgetActionButtons.vue"
export default component.exports